{
  "clear": "Rensa",
  "invalid": "(ogiltigt)",
  "loading": "Läser in...",
  "noResults": "Inga resultat"
}
